import { Col, Divider, Row, Select } from 'antd'
import * as R from 'ramda'
import React from 'react'
import countries from '../../i18n/countries.json'

const lookupCountry = (iso2) => countries[iso2.toUpperCase()]

export const toIso3 = (iso2) => lookupCountry(iso2).iso3

export const Flag = ({ iso2, showIso3 = false }) => {
  const country = lookupCountry(iso2)

  return (
    <div className="Flag">
      <span className={`flag-icon flag-icon-${country.iso2 && country.iso2.toLowerCase()}`} />
      {showIso3 && (
        <span style={{ whiteSpace: 'nowrap', paddingLeft: '0.75em' }}>{country.iso3}</span>
      )}
    </div>
  )
}

const countryOptions = R.values(countries).map(({ iso2, iso3, name }) => (
  <Select.Option key={iso2} value={iso2} title={name}>
    <span className={`flag-icon flag-icon-${iso2.toLowerCase()}`} />
    <span style={{ paddingLeft: '0.75em' }}>{name}</span>
    <span className="select-country-iso">{iso3}</span>
  </Select.Option>
))

/**
 * This cannot be a functional component as it's doing some magic with refs
 */
export class CountrySelect extends React.Component<any, any> {
  compareFilterOption = (inputValue, option) =>
    option.props.title && option.props.title.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1

  render() {
    const { value, onChange, showSelection } = this.props

    const selectSpan = showSelection ? 18 : 24

    return (
      <Row>
        <Col span={selectSpan}>
          <Select
            value={value && countries[value].name}
            onChange={onChange}
            showSearch
            filterOption={this.compareFilterOption}
            optionLabelProp="name">
            {countryOptions}
          </Select>
        </Col>
        {value && showSelection ? (
          <Col span={6} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Divider type="vertical" />
            <Flag iso2={value} showIso3 />
          </Col>
        ) : null}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/countries/index.tsx